"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
/**
 * Combines user title, firstName, and lastName into a single string, filtering out empty values
 * @param {Object} user - User object with title, firstName, and lastName properties
 * @returns Combined name string
 */
var _default = exports["default"] = function _default() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return [user.title, user.firstName, user.lastName].filter(function (attr) {
    return attr;
  }).join(' ');
};